'use strict';

var d3 = require('d3');
var Scales = function Scales(params, data, graphDirection) {
  var DIRECTIONS = {
    RTL: 'right-to-left',
    LTR: 'left-to-right'
  };
  var xRange = [0, 0],
    yRange = [0, 0];
  function adjustRange(newRange, oldRange) {
    newRange[0] = Math.min(newRange[0], oldRange[0]);
    newRange[1] = Math.max(newRange[1], oldRange[1]);
  }
  data.forEach(function (c) {
    adjustRange(xRange, d3.extent(c.curveData, function (d) {
      return d.dtd;
    }));
    adjustRange(yRange, d3.extent(c.curveData, function (d) {
      return d.demand;
    }));
  });
  yRange[1] = 1.1 * yRange[1];
  if (graphDirection === DIRECTIONS.RTL) {
    xRange = xRange.reverse();
  }
  var x = d3.scale.linear().domain(xRange).range([0, params.width]);
  var y = d3.scale.linear().domain(yRange).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;